module.exports = __webpack_public_path__ + "static/img/p_07.8150afd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_07.jpg
// module id = 4JKk
// module chunks = 9